
import { Button } from "@/components/ui/button";
import { Save, Check, X } from "lucide-react";
import { ServiceProviderRow } from "@/types/supabase";

interface AdminEditListingActionsProps {
  listing: ServiceProviderRow;
  isUpdatePending: boolean;
  isStatusPending: boolean;
  onSave: () => void;
  onApprove: () => void;
  onReject: () => void;
}

const AdminEditListingActions = ({
  listing,
  isUpdatePending,
  isStatusPending,
  onSave,
  onApprove,
  onReject
}: AdminEditListingActionsProps) => {
  const isDisabled = isUpdatePending || isStatusPending;

  return (
    <div className="flex flex-wrap justify-end gap-3">
      <Button 
        onClick={onSave}
        className="bg-whatsapp hover:bg-whatsapp-dark flex items-center"
        disabled={isDisabled}
      >
        <Save className="h-4 w-4 mr-2" />
        {isUpdatePending ? "Saving..." : "Save Changes"}
      </Button>
      
      {listing.status === "pending" && (
        <>
          <Button
            onClick={onApprove}
            disabled={isDisabled}
            className="bg-green-600 hover:bg-green-700 flex items-center"
          >
            <Check className="h-4 w-4 mr-2" />
            {isStatusPending ? "Processing..." : "Approve Listing"}
          </Button>
          
          <Button
            onClick={onReject}
            disabled={isDisabled}
            variant="destructive"
            className="flex items-center"
          >
            <X className="h-4 w-4 mr-2" />
            Reject Listing
          </Button>
        </>
      )}
      
      {listing.status === "rejected" && (
        <Button
          onClick={onApprove}
          disabled={isDisabled}
          className="bg-green-600 hover:bg-green-700 flex items-center"
        >
          <Check className="h-4 w-4 mr-2" />
          Approve Listing
        </Button>
      )}
    </div>
  );
};

export default AdminEditListingActions;
